// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"d8ad0abe","864":"e7ecf837"}[chunkId] + ".chunk.js";
};